export default {
  setAlertas(state,a){
    state.alertasArray = a;
  }
}